import { RosterRequestDataNewReservation } from 'generated/graphql';

type PreferredHotelProps = {
  requestData: RosterRequestDataNewReservation;
};

const PreferredHotel = ({ requestData }: PreferredHotelProps) => {
  if (!requestData) {
    return null;
  }

  return (
    <>
      <h2 className="mb-5 text-lg text-primaryGray">
        Preferred Hotel Information
      </h2>
      <div>
        <div className="mb-2">
          <span className="text-primaryGray">Hotel Name:</span>
          <span>{requestData.preferredHotelName}</span>
        </div>
        <div className="mb-2">
          <span className="text-primaryGray">Address: </span>
          <span>{requestData.preferredHotelAddress}</span>
        </div>
        <div className="mb-2">
          <span className="text-primaryGray">Email: </span>
          <span>{requestData.preferredHotelEmail}</span>
        </div>
        <div className="mb-2">
          <span className="text-primaryGray">Phone: </span>
          <span>{requestData.preferredHotelPhone}</span>
        </div>
      </div>
    </>
  );
};

export default PreferredHotel;
